var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"footer-nav"},_vm._l((_setup.getRenderMenus),function(item,index){return _c(_setup.FooterMenuItemMob,{key:index,attrs:{"menu":item},on:{"click":_setup.handleSurfNavigate}})}),1),_c(_setup.FooterChannelMob)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }